<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ errors, failedRules }"
      :data-unit-test="`${stepId}_${questionId}`"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      :rules="fieldValidationRules"
    >
      <qz-number-input
        v-model.number="questionData[questionFields.field]"
        :prefix="inputPrefix"
        :suffix="inputSuffix"
        :error-messages="getFieldErrors('field', failedRules, errors)"
        :placeholder="helpers.getPlaceholderResponsiveText(placeholder || '', isMobile)"
        :maxlength="maxLength"
        :without-separators="withoutSeparators"
        :data-test="fieldTrackerId"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';
import { snakeCase } from 'lodash';

export default {
  name: 'question-base-number',
  extends: QuestionBase,
  components: { QuestionBaseWrapper },
  data () {
    return { fields: ['field'] };
  },
  props: {
    placeholder: {
      default: null,
      validator: value => (typeof value === 'string') || value === false,
    },
    maxLength: {
      type: Number,
      default: 6,
    },
    inputPrefix: {
      type: String,
      default: null,
    },
    inputSuffix: {
      type: String,
      default: null,
    },
    withoutSeparators: {
      type: Boolean,
      default: false,
    },
    minVal: {
      type: Number,
      default: null,
    },
  },
  computed: {
    fieldValidationRules () {
      if (this.validationRules) {
        return this.helpers.parseRules(this.validationRules.field, this.stepData);
      }

      return 'required';
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.field);
    },
  },
};
</script>
